<template>
  <div class="w-full">
    <vs-alert title="Catatan" class="my-5">
      Berikut ini merupakan laporan presensi harian petugas MPP yang bisa dipilih berdasarkan tanggal presensi.
    </vs-alert>
    
    <div class="vx-col w-full">
      <vx-card class="my-5">
        <div class="w-full flex flex-col md:flex-row">
          <div class="w-full flex">
            <div class="w-full md:w-1/2 px-3 mb-1">
              <div class="mb-2">Pilih Tanggal Presensi</div>
              <datepicker 
                v-model="date" 
                :format="'yyyy-MM-dd'" 
                :disabled-dates="datepickerConfig.disabledDates" 
                :minimumView="'day'" 
                placeholder="Pilih Tanggal"/>
            </div>
            <div class="w-full md:w-1/3 px-3 mb-1">
              <div class="mb-2">.</div>
              <vs-button
                class="justify-center"
                type="border"
                size="medium"
                icon-pack="feather"
                icon="icon-download"
                :disabled="!isUserCanDownload"
                @click="downloadReport()"
                >Download Laporan
              </vs-button>
            </div>
          </div>
          <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import {SELECT_OPTION_YEAR_LIST, SELECT_OPTION_MONTH_LIST } from "@/const/attendance";

export default {
  components: {
    "v-select": vSelect,
    Datepicker,
    SELECT_OPTION_YEAR_LIST,
    SELECT_OPTION_MONTH_LIST
  },
  data() {
    return {
      date: '',
      datepickerConfig: {
        disabledDates : {
          days : [6,0],
          dates: [],
          ranges: [{
              from: new Date(Date.now() - ( 3600 * 1000 * 24)),
              to: new Date(2030, 0, 1)
          }],
        },
      }
    }
  },
  computed:{
    isUserCanDownload(){
      return this.date == '' ? false : true;
    }
  },
  mounted(){
    this.getDisabledDates();
  },
  methods:{
    downloadReport(){
      let data = {
        date: moment(this.date).format("YYYY-MM-DD"), 
        type: 'daily_report'
      };

      this.$http.get("/app/secure/attendance-info/download-report",  {params: data})
      .then(response => {
        let url = response.data.data.report;
        window.setTimeout(function(){ 
          window.open(url);
        },500);
      })
      .catch(e => {
        this.parseError(e);
      });
    },
    getDisabledDates(){
      this.$http.get("/app/secure/attendance-info/disabled-dates")
      .then(response => {
        let disabled = response.data.data.disabled_dates;
        this.datepickerConfig.disabledDates.dates = disabled.map(item => {
          return moment(item)._d;
        });
      })
      .catch(e => {
        this.parseError(e);
      });
    },
  }
};
</script>
